import { Button } from '@cian/ui-kit';
import * as React from 'react';

interface INewbuildingBrokerButtonProps {
  loading: boolean;
  onClick(): void;
}

export const NewbuildingBrokerButton = ({ loading, onClick }: INewbuildingBrokerButtonProps) => (
  <Button
    loading={loading}
    size="XS"
    theme="fill_success_primary"
    onClick={onClick}
    data-testid="NewbuildingBrokerButton"
  >
    Провести сделку
  </Button>
);
